/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable guard-for-in */
import React, { useState, useEffect, FormEvent } from 'react';

import { useParams, useHistory } from 'react-router-dom';

import 'react-credit-cards/es/styles-compiled.css';

import MaskedInput from 'react-text-mask';
import { Container, Sidebar, ContainerForm, Form, Loading } from './styles';

import api from '../../services/ecommerce';
import { HandleFormatMoney } from '../../services/utils';

interface Param {
  productId: string;
}

interface PaymentRequest {
  email: string;
  username: string;
  name: string;
  description: string;
  price: number;
  user_id: string;
}

const Checkout: React.FC = () => {
  const [name, setName] = useState('');
  const [document, setDocument] = useState('');
  const [phone, setPhone] = useState('');
  const [payment, setPayment] = useState<PaymentRequest | null>(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState('');

  const history = useHistory();

  const { productId } = useParams<Param>();

  async function getProduct(paymentIdentifier: string): Promise<void> {
    try {
      setLoading(true);
      setPayment(null);
      const { data } = await api.get<PaymentRequest>(
        `products/unique?id=${paymentIdentifier}`,
      );
      setPayment(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // window.location.href = 'https://app.qesh.ai';
    }
  }

  async function registerClient(e: FormEvent): Promise<void> {
    e.preventDefault();

    if (!phone) return;
    if (!document) return;
    if (!name) return;

    setLoading(true);
    const phoneFormatted = phone
      .replace(/\s/, '')
      .replace('(', '')
      .replace(')', '');

    const documentFormatted = document.replace(/[\s,\-,.]/g, '');

    try {
      await api.post(
        'clients',
        {
          phone: `${phoneFormatted}`,
          document: documentFormatted,
          name,
        },
        {
          headers: {
            user: payment?.user_id,
          },
        },
      );

      const { data: addressId } = await api.post(
        'clients/address',
        {
          zip_code: '34006042',
          street: 'Alameda do Inga',
          number: '16',
          complement: 'nenhum',
          neighborhood: 'Vale do Sereno',
          city: 'Nova Lima',
          state: 'MG',
          country: 'Brasil',
        },
        {
          headers: {
            phone: `${phoneFormatted}`,
            user: payment?.user_id,
          },
        },
      );

      await api.post(
        'carts',
        {
          product_id: productId,
          quantity: 1,
        },
        {
          headers: {
            user: payment?.user_id,
            phone: `${phoneFormatted}`,
          },
        },
      );

      const { data } = await api.post(
        'purchases',
        {},
        {
          headers: {
            user: payment?.user_id,
            phone: `${phoneFormatted}`,
          },
        },
      );

      await api.put(
        `purchases/${data.id}`,
        {
          address_id: addressId.id,
        },
        {
          headers: {
            user: payment?.user_id,
            phone: `${phoneFormatted}`,
          },
        },
      );

      await api.put(
        `purchases/${data.id}`,
        {
          payment_type: 'credit_card',
        },
        {
          headers: {
            user: payment?.user_id,
            phone: `${phoneFormatted}`,
          },
        },
      );

      const { data: dadosPayment } = await api.get(`purchases/${data.id}`, {
        headers: {
          user: payment?.user_id,
          phone: `${phoneFormatted}`,
        },
      });

      setLoading(false);
      const { link } = dadosPayment;
      const linksplited = link.split('/');
      const linke = linksplited[linksplited.length - 1];
      history.push(`/${linke}`);
    } catch (err) {
      setLoading(false);
    }
  }

  useEffect(() => {
    getProduct(productId);
  }, [productId]);

  return (
    <>
      <Container>
        <Loading hasLoading={loading}>
          <section />
          <span />
          <div />
        </Loading>

        {payment && (
          <>
            <ContainerForm>
              <>
                <Form onSubmit={registerClient}>
                  <div>
                    <div>
                      <input
                        type="text"
                        placeholder="Nome"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div>
                      <MaskedInput
                        type="text"
                        name="document"
                        placeholder="CPF"
                        value={document}
                        onChange={(e) => setDocument(e.target.value)}
                        mask={[
                          /\d/,
                          /\d/,
                          /\d/,
                          '.',
                          /\d/,
                          /\d/,
                          /\d/,
                          '.',
                          /\d/,
                          /\d/,
                          /\d/,
                          '-',
                          /\d/,
                          /\d/,
                        ]}
                      />
                    </div>
                    <div>
                      <MaskedInput
                        type="text"
                        name="phone"
                        placeholder="Telefone (Celular)"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        mask={[
                          '(',
                          /\d/,
                          /\d/,
                          ')',
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                      />
                    </div>
                  </div>

                  <div>
                    <button type="submit">Continuar</button>
                  </div>
                  {!!error && (
                    <div
                      style={{
                        border: '1px solid #ff9377',
                        padding: 12,
                        borderRadius: 4,
                        color: '#c5310a',
                      }}
                    >
                      {error}
                    </div>
                  )}
                </Form>
              </>
            </ContainerForm>
            <Sidebar>
              <header>
                <img
                  // https://app.qesh.ai/logo_qesh.png
                  src="https://app.qesh.ai/logo_q.png"
                  alt="Qesh Payment"
                  width="30"
                />
              </header>
              <section>
                <span />
                <h3>{payment.name}</h3>
              </section>
              <section>
                {/* <span>Cobrança criada por</span> */}
                <h4>{payment.description}</h4>
              </section>
              {/* <section>
                <span>Para</span>
                <h4>{payment.payment.payer_name}</h4>
              </section> */}
              {/* <section>
                <span>Metodo de pagamento</span>
                <h4>
                  {payment.payment.payment_type === 'CreditCard'
                    ? 'Cartão de Crédito'
                    : 'Cartão de Débito'}
                </h4>
              </section> */}
              <footer>
                <span>Valor</span>
                <div>{HandleFormatMoney(payment.price)}</div>
              </footer>
            </Sidebar>
          </>
        )}
      </Container>
    </>
  );
};

export default Checkout;
